import { mixed } from 'yup'
import type { AriaAttributes } from 'react'

// html element aria-attributes property
export const ariaAttributesSchema = mixed<AriaAttributes>().optional()
